// extracted by css-extract-rspack-plugin
export default {"code":"YTJ6km5p1esVsLbX","small":"r8H5fjN2Nf4WRZlp","medium":"jGLhhlYcOw0XEtmS"};